import ContactDetails from "./ContactDetails";

const CustomerServiceDetails = () => (
  <ContactDetails>
    <div style={{ fontWeight: "bold" }}>Customer Services</div>
    <div className="wmnds-m-t-md">Phone: 0345 034 8670</div>
    <div className="wmnds-m-t-md">Monday to Friday, 8:00AM to 6:00PM</div>
    <div className="wmnds-m-t-md">Saturday, 8:00AM to 4:00PM</div>
    <div>Sundays and Bank Holidays, Closed</div>
  </ContactDetails>
);

export default CustomerServiceDetails;
